import FusionAuthClient from '@fusionauth/typescript-client'

const API_KEY = `${process.env.REACT_APP_FUSION_API_KEY}`
const TENANT_ID = `${process.env.REACT_APP_FUSION_TENANT_ID}`

const API = new FusionAuthClient(
    API_KEY,
    'https://auth.coinprofile.co',
    TENANT_ID
)
export default API
